import { Zap } from "lucide-react";
import { Section } from "@/components/plan/common";

export default function QuickWinsSection({ wins }) {
  if (!wins?.length) return null;
  return (
    <Section icon={Zap} title="First 48 hours: quick wins" tint="emerald">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {wins.map((q, i) => (
          <div key={`qw-${i}-${q.slice(0, 20)}`} className="bg-white border border-zinc-200 rounded-xl p-4 text-sm text-zinc-800 flex gap-3">
            <div className="h-6 w-6 rounded-full bg-emerald-500 text-white text-xs flex items-center justify-center shrink-0">{i + 1}</div>
            {q}
          </div>
        ))}
      </div>
    </Section>
  );
}
